import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { BehaviorSubject, combineLatest, delay, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../core/user.service';
import { FileListService } from '../../file-list/services/file-list.service';
import { PathListApiInput, PathListApiOutput } from '../../shared/models/api';
import { Action, CellTypes, Column, DataListComponent, IconButton, UtilService, MenuItems } from '@material-library';
import { FileItemService } from 'src/app/file/file-item.service';
import { B64Pipe } from 'src/app/shared/pipes/b64.pipe';
import { ThumbnailsService } from '../services/thumbnails.service';
import { FileItem } from 'src/app/shared/models/files.model';
import { BlendEvent, ErrCode, LinkListItem, PermissionActions, User, WebpathActionType } from 'src/app/shared/models';
import { LoggerService } from 'src/app/core/logger.service';
import * as FileListActions from '../../actions/file-list.actions';
import * as fromRoot from '../../reducers';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { IFile } from 'src/sync';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { BuildTransferItemService } from 'src/app/transfer/services/build-transfer-item.service';
import { canBrowserOpen } from 'src/app/shared/func';
import { TransferService } from 'src/app/transfer/services/transfer.service';
import { SkuService } from 'src/app/shared/services/sku.service';
import { IDuplicateNameMap } from 'src/app/shared/models/move.model';
import { MoveActionsService } from 'src/app/shared/services/move-actions.service';
import { TransferStatus } from 'src/app/transfer/models/transfer.model';
import { FileViewService } from 'src/app/file/file-view.service';
import { RootLayoutConfigService } from 'src/app/shared/layout/root-layout/root-layout-config.service';
import { RunUploadFolderService } from 'src/app/transfer/services/run-upload-folder.service';
import { ProcessIndicatorService } from 'src/app/shared/services/process-indicator.service';
import { DeleteCopyPlaceholders, InsertCopyPlaceholders } from 'src/app/actions/file-list.actions';
import { Title } from '@angular/platform-browser';
import { FileInfoDialogComponent } from '../dialog-file-info/dialog-file-info.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { BlendService } from 'src/app/shared/services/blend.service';
import { MoveDialogComponent } from '../actions/move-dialog/move-dialog.component';
import { IPaginationConfig } from "../../shared/types";
import { BaseFileListComponent } from "../../shared/components/base-file-list/base-file-list.component";

interface SearchConfig {
  searchValue: string;
}

interface RootLayoutConfigActions {
  moreTooltipText?: string;
  actions?: any[];
  limit?: number;
  rowData?: any;
}

interface RootLayoutConfig {
  isCustomLayout?: boolean;
  breadcrumbActions?: RootLayoutConfigActions;
  useBreadcrumbItems?: boolean;
}
import { ChargebeeService } from 'src/app/shared/services/chargebee.service';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
})
export class FileListComponent extends BaseFileListComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit {
  @ViewChild('dataList') dataListElement!: DataListComponent & {
    scrollContainer: ElementRef<HTMLElement>;
  };
  @ViewChild('cellTemplate') cellTemplateRef: TemplateRef<any>;
  @ViewChild('iconTemplate') iconTemplateRef: TemplateRef<any>;
  @ViewChild('fileInputFab') fileInputFab!: ElementRef<HTMLInputElement>;
  @ViewChild('dialoglinkcontent') dialoglinkcontent: TemplateRef<any>;
  @ViewChild('moveDialog') moveDialog: MoveDialogComponent;

  private fileListState$ = this.store.select(fromRoot.getFileListState);
  
  public defaultSyncId: any;
  
  public selectedRows: FileItem[] = [];
  public cwd: FileItem;
  public isRoot: boolean;
  public isVault: boolean;
  public isReadOnly = 0;
  public syncId: number;
  public histId: number;
  public activeTab = 'Info';
  public user: User;

  public clearSelectionValue: boolean = false;
  public isSmScreen: boolean = false;
  public openInfoPanel: boolean = false;
  public bulkActions: Array<Action> = [];
  public isAuth: boolean;
  public url: string;

  public isRename: boolean = false;
  public itemToRename: FileItem;

  public selectedManageShareItem: IFile[];
  public openManageShareFolderDialog: boolean = false;
  public openManageShareFolderDialogOpenState: number = -1;
  public isFabMenuOpen: boolean = false;
  public openCreateFileDialog: boolean = false;
  public openUploadDialog: boolean = false;
  public opennewFolderDialog: boolean = false;

  public linkItem: LinkListItem | IFile;

  public openShareFolderDialog: boolean = false;
  public openDialogLinkDialog: boolean = false;
  public permissionActions = PermissionActions;
  public openDialogPurge: boolean = false;
  public openDialogRestore: boolean = false;

  public purgeLimit: number;
  public showUpgradeButton: boolean = true;
  public showUpgradeMessage: boolean = true;
  public selectedShareItem: FileItem[];
  public dropFolder?: FileItem;
  private dragCount = 0;
  public isGridView = false;

  public openDeleteDialog: boolean = false;
  public isMoveDialogOpen: boolean = false;
  public actionMoveOrCopy: WebpathActionType = WebpathActionType.MOVE
 
  private isLoaded = false;
 
  // Current minus height values
  private currentMinusHeightListView = this.minusHeightForListViewDesktop;
  private currentMinusHeightGridView = this.minusHeightForGridViewDesktop;

 
  public errCode?: ErrCode;
  public headIcon$ = new BehaviorSubject<string>('');
  public fromBreadcrumb: boolean = false;
  public moveDialogParentDir: IFile | PathListApiOutput;
  public autoMove: boolean;
  public draggedOver: FileItem;
  public dndDialog: {
    opened: boolean;
    title?: string;
    message?: string;
  } = {
    opened: false,
  }


  public scrollTop;
  private restoredScroll;
  public listService = this.fileListService;

  protected onSortChange = (menuItem: MenuItems | string) => {
    const value = !menuItem ? 'nameAsc' : (typeof menuItem === 'string') ? menuItem : menuItem.value;
    switch (value) {
      case 'nameAsc':
        this.listService.sortList('name', true);
        break;
      case 'nameDesc':
        this.listService.sortList('name', false);
        break;
      case 'dateOldest':
        this.listService.sortList('usertime', false);
        break;
      case 'dateNewest':
        this.listService.sortList('usertime', true);
        break;
      case 'sizeAsc':
        this.listService.sortList('size', false);
        break;
      case 'sizeDesc':
        this.listService.sortList('size', true);
        break;
      default:
        break;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside() {
      this.isFabMenuOpen = false;
  }

  constructor(
    public route: ActivatedRoute,
    private userService: UserService,
    protected fileListService: FileListService,
    protected fileItemService: FileItemService,
    public b64: B64Pipe,
    private thumbnailsService: ThumbnailsService,
    public logger: LoggerService,
    private store: Store<fromRoot.State>,
    protected utils: UtilService,
    protected router: Router,
    private breakpointObserver: BreakpointObserver,
    private broadcastService: BroadcastService,
    private viewContainerRef: ViewContainerRef,
    private snackbarService: SnackbarService,
    private changeDetectorRef: ChangeDetectorRef,
    private buildTransferItemService: BuildTransferItemService,
    private transferService: TransferService,
    private skuService: SkuService,
    private moveActionsService: MoveActionsService,
    private fileViewService: FileViewService,
    private rootLayoutConfig: RootLayoutConfigService,
    private runUploadFolderService: RunUploadFolderService,
    private processIndicatorService: ProcessIndicatorService,
    private pageTitleService: Title,
    private dialogService: DialogService,
    private blendService: BlendService,
    private chargebeeService: ChargebeeService,
    private ngZone: NgZone,
  ) {
    super(utils, fileItemService, route);
  }
  
  async ngOnInit() {
    super.ngOnInit();
    this.syncId = this.route.snapshot.params['sync_id'];
    this.showDeleted = +this.route.snapshot.queryParams['showDeleted'] || 0;
    this.isAuth = this.userService.isAuthenticated();
    this.user = this.userService.getUser();

    this.restoreHistoryState();
    this.rootLayoutConfig.updateConfig({
      isCustomLayout: true,
    })

    this.initTableData();
    this.initSubscribers();

    // Combine observables for route data, params, and queryParams to trigger updates based on route changes
    combineLatest([
      this.route.data, // For route-specific static data
      this.route.params, // For dynamic route parameters (e.g., 'sync_id')
      this.route.queryParams // For query parameters (e.g., 'view=grid')
    ])
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe(async ([data, params, queryParams]) => {
      this.restoreHistoryState();
      this.isPaginationInitialized = false;
      this.selectedRows = [];
      this.isGridView = queryParams['view'] === 'grid';
      this.isVault = this.router.url.includes('/vault');
      this.searchConfig.searchValue = '';
      this.fileListService.filterList('');
      
      if (data.defaultSyncIdKey) {
        this.defaultSyncId = this.userService.get(data.defaultSyncIdKey);
      }
      
      await this.loadInitialData();
    });
    
    this.broadcastService.on('event:file-list.reload')
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe((params) => {
      if (!this.isMoveDialogOpen) {
        this.reload(params);
      }
    });
 
    this.purgeLimit = await this.skuService.getDataLimit();
    this.showUpgradeButton = this.purgeLimit !== 365;
    this.showUpgradeMessage = this.purgeLimit !== 365;
  }


  restoreHistoryState() {
    this.restoredScroll = false;
  }


  getState() {
    return history.state;
  }
  
  updateHistoryState(switches: { scroll?: boolean }, from?: string) {
    if (this.isLoading) return;
    history.replaceState({
      url: this.router.url,
      pagination: this.paginationConfig,
      scroll: switches.scroll && this.dataListElement?.scrollContainer?.nativeElement?.scrollTop !== undefined
        ? this.dataListElement.scrollContainer.nativeElement.scrollTop
        : history.state.scroll,
      currentIndex: this.currentIndex,
    }, '');
  }

  public updateDataContainerScroll() {
    this.scrollTop = history.state.scroll;
  }
  
  public ngAfterContentInit(): void {
    this.fileListState$
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe((data) => {
    
      if (data.error) {
        this.errCode = data.error;
        this.isLoading = false;
      }
      // @TODO once this is ported to ng6, most of the subscription can be
      // tightened up to select specific areas to prevent excessive loading
      if (data.cwd) {
        this.cwd = data.cwd;
        this.isReadOnly = this.cwd.is_readonly;
        this.isRoot = data.cwd.sync_id == this.defaultSyncId;
        this.syncId = this.cwd.sync_id;

        if (data.loaded && !this.isRoot) {
          this.pageTitleService.setTitle(
            `${this.cwd.name} | ${this.PAGE_TITLE}`
          );
        }

        if (data.loaded) {
          this.rootLayoutConfig.patchConfig({
            breadcrumbActions: {
              moreTooltipText: data.cwd.is_shared ? 'Manage shared folder' : 'Manage folder',
              actions: this.fileMenuActions(true),
              limit: 1,
              rowData: data.cwd,
            }
          });
        }
      }
      
      if (!this.fileList.length && (!data.loaded || !data.sorted)) return;

      this.isRoot = this.syncId == this.userService.get('syncus_sync_id') || this.syncId == this.userService.get('web_sync_id');
      this.histId = data.hist_id;
               
      let itemsToDisplay = data.pathlist;
      if (data.filterString) {
          itemsToDisplay = data.filteredPathlist;
          this.resetScrollToTop();
      }
      
      this.fileList = itemsToDisplay.filter((linkItem) => linkItem.is_deleted === this.showDeleted);
      
      this.selectedRows = this.selectedRows.map(
            (selectedRow) => this.fileList.find((row) => row.sync_id === selectedRow.sync_id)
        ).filter(Boolean);

      this.currentIndex = this.getState().currentIndex ?? 0;
      if (!this.isPaginationInitialized && this.fileList.length) {
          this.initializePagination();
      }
      this.setPageData();

      this.isLoading = false;
      this.isLoaded = data.loaded;

    });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.rootLayoutConfig.updateConfig(null);
        this.fileListService.clearResources();
        this.dataSource = [];
        this.fileList = [];
    }

    loadInitialData() {
        if (this.isLoading) return;
        this.isLoading = true;
        const input = new PathListApiInput();
        this.showDeleted = +this.route.snapshot.queryParams['showDeleted'] || 0;
        const syncId = this.route.snapshot.params['sync_id']
        input.sync_id = syncId ? parseInt(syncId, 10) : this.defaultSyncId;
        input.hist_id = parseInt(this.route.snapshot.queryParams['histId'], 10) || 0;
        input.showdeleted = this.showDeleted;
        input.is_vault = this.isVault;

        this.isRoot = input.sync_id === this.userService.get('syncus_sync_id') || input.sync_id === this.userService.get('web_sync_id');
        this.rootLayoutConfig.patchConfig({ useBreadcrumbItems: !this.isRoot })
        this.store.dispatch(new FileListActions.FileListRefreshAction(input));
    }

  resetScrollToTop(): void {
  const el = this.dataListElement?.scrollContainer?.nativeElement;
  if (el) {
    this.ngZone.runOutsideAngular(() => {
      el.scrollTop = 0;
        this.dataListElement.scrollContainer.nativeElement.scrollTop = 0;
        this.updateHistoryState({ scroll: true }, 'handlePageChange');
     });
     }
  }

  public shouldLoadList(data) {
    if (this.isRoot) {
      return (
        data.pathlist.length &&
        data.pathlist[0].is_vault === this.isVault
      );
    } else {
      return data.sync_id == +(this.route.snapshot.params['sync_id'] || 0);
    }
  };


  onRowDoubleClick = (item: any) => {
    const link = this.getItemLink(item);
    this.router.navigate([link],{ queryParams: {tab:this.isVault?'vault':'file'} });
  }
  
  navigateToNestedRoute(syncId: string) {
    const currentParams = this.route.snapshot.queryParams;
    const viewMode = currentParams['view'] || 'list';
    let base = this.router.url.match(/^(\/[^\/\?]*)/)[0];
    if (base === '/vault') {
      base = '/files';
    }
    this.router.navigate([base, syncId], {
      relativeTo: this.route,
      queryParams: { ...currentParams, view: viewMode },
      queryParamsHandling: 'merge',
    });
  }

  getItemLinkQueryParams = (item) => {
    if (item.type === 'dir') {
      const currentParams = this.route.snapshot.queryParams;
      const viewMode = currentParams['view'] || 'list';
      return { ...currentParams, view: viewMode };
    }
    else {
      return {tab:this.isVault?'vault':'file'};
    }
  }

  public getItemLink = (item) => {    
    this.user = this.userService.getUser();
    let type = 'default';
    if (item.type == 'dir' && (this.router.url.includes('files') || this.router.url.includes('starred') || this.router.url.includes('vault'))) {
      return `${this.router.url.match(/^(\/[^\/\?]*)/)[0]}/${item.sync_id}`

    }
    else if (this.fileItemService.isImage(item)) {
      type = 'image';
    } else if (this.fileItemService.isText(item)) {
      type = 'text';
    } else if (
      this.fileItemService.isPDF(item) &&
      (item.context == 'link' || item.context == 'applink') &&
      item.previewonly
    ) {
      type = 'doc';
    } else if (this.fileItemService.isPDF(item) && item.context == 'files') {
      type = 'doc';
    } else if (this.display_office(item)) {
      type = 'office';
    } else if (this.display_doc(item)) {
      type = 'doc';
    } else if (this.fileItemService.isVideo(item)) {
      type = 'video';
    } else if (this.fileItemService.isAudio(item)) {
      type = 'audio';
    } else {
      type = 'default';
    }
    return `/file/${item.sync_id}/view/${type}`
  };

  public display_doc(item) {
    return (
      this.fileItemService.isDocument(item) &&
      // only compat links
      ((item.compat && (item.context == 'link' || item.context == 'applink')) ||
        item.context == 'files')
    )
  }

  public display_office(item) {
    return (
      this.fileItemService.isMSOffice(item, 'embedview') &&
      // Only enabled in files, for now
      item.context === 'files' &&
      this.user.is_office === 1
    );
  }

  onViewFileClick = (data: FileItem) => {
    this.router.navigate([this.getItemLink(data)],{ queryParams: {tab:this.isVault?'vault':'file'} });
  }

  onSearch = (searchValue: string) => {
    this.searchConfig.searchValue = searchValue;
    this.fileListService.filterList(searchValue);
    this.handleFilterOrSortingChanged();
  }

  onDataContainerScroll = () => {
    this.updateHistoryState({scroll:true},'handleScroll');
  }
  
  onViewHistory = (data) => {
    const parent = this.isVault ? 'vault' : 'files';

    this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'View version history' });

    this.router.navigate([`${parent}/file-history/${data.sync_id}`])
  }
  onView = (data) => {
    const parent = this.isVault ? 'vault' : 'files';
    this.router.navigate([`${parent}/file-history/${data.sync_id}`])
  }
  onRowClick = () => {
  }

  onCloseInfoPanel = () => {
    this.openInfoPanel = false;
  }

  public isOpenable(item) {
    if (this.isMSOffice(item)) {
      return false;
    }

    if (!canBrowserOpen(item.name)) {
      return false;
    }
    return true;
  }

  public showOfficeView(data) {
    return (
      this.fileItemService.isMSOffice(data, 'view') &&
      this.isAuth &&
      this.user.is_office &&
      this.user.is_pro
    );
  }

  public showOfficeEdit(item) {
    return this.fileItemService.isMSOffice(item, 'edit') && this.isAuth;
  }

  public isMSOffice(item) {
    const app = this.fileItemService.getMSOfficeApp(item);
    if (app === 'None') {
      return false;
    }
    return true;
  }

  public openOfficeView(item: FileItem) {
    this.router.navigate(['/file', item.sync_id, 'view', 'officefsv'],{ queryParams: {tab:this.isVault?'vault':'file'} });
  }

  public openOfficeEdit(item: FileItem) {
    if (this.user.can_preview) {
      this.router.navigate(['/file', item.sync_id, 'view', 'officefse'],{ queryParams: {tab:this.isVault?'vault':'file'} });
    }
  }
  resetFabProperties = () => {
    this.openCreateFileDialog = false;
    this.openUploadDialog = false;
    this.opennewFolderDialog = false;
  }
  fabClick = (e:Event) => {
    e.stopPropagation();
    
    if (!this.isFabMenuOpen) {
      this.blendService.track(BlendEvent.BUTTON_CLICKED, {
        button_text: '+ add new item',
      });
    }

    this.isFabMenuOpen = !this.isFabMenuOpen;
    this.resetFabProperties();
  }
  fabFileOnClick = () => {
    this.openCreateFileDialog = true;
    this.isFabMenuOpen = false;
  }
  fabFolderOnClick = () => {
    this.isFabMenuOpen = false;
    this.opennewFolderDialog = true;
  }
  fabUploadOnClick = () => {
    this.isFabMenuOpen = false;
    this.openUploadDialog = true;
  }
  fabUploadOnClickXs = () => {
    this.isFabMenuOpen = false;
    if (this.fileInputFab) {
      this.fileInputFab.nativeElement.value = '';
      this.fileInputFab.nativeElement.click();
    }
  }

  fabUpload = (event: any) => {
    const files = event.target.files;
    this.onUpload(files);
  }

  onUpload = (files) => {
    this.transferService.queueUpload(files, false);
  }

  reload(params: any) {
        if (!this.isLoaded || params?.hist_id == this.histId) {
            return;
        }
        const input = new PathListApiInput();
        input.sync_id = this.cwd.sync_id;
        input.hist_id = 0;
        input.showdeleted = parseInt(this.route.snapshot.queryParams['showDeleted'], 10);
        input.is_vault = this.isVault;
        this.isLoaded = false;

        this.store.dispatch(new FileListActions.FileListRefreshAction(input));
    }
    
    toggleDeleted = async () => {
     const showDeleted = Number(this.route.snapshot.queryParams['showDeleted'] || 0) === 1 ? 0 : 1;
     this.showDeleted = showDeleted;
     this.dataSource = [];
     await this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { showDeleted },
      queryParamsHandling: 'merge'
     });
    
     this.initTableData();
     this.assignTemplateRefs();
     
  }

  public showDownload(item) {
    if (
      (item.context == 'link' || item.context == 'applink') &&
      item.previewonly == 8
    ) {
      return false;
    } else {
      return true;
    }
  }
  public async downloadCompat(data: FileItem) {
      const url = await this.buildTransferItemService.getCompatUrl(data, this.buildTransferItemService.ACT_DOWNLOAD)
      window.location.href = url;
  }

  private initSubscribers(): void {
    this.breakpointObserver
      .observe([`(max-width: 904px)`])
      .pipe(takeUntil(this.destroySubscriptions$))
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          // Condition for sm/xs screens
          this.isSmScreen = true;
          this.currentMinusHeightListView = this.minusHeightForListViewMobile;
          this.currentMinusHeightGridView = this.minusHeightForGridViewMobile;
        } else {
          this.isSmScreen = false;
          this.currentMinusHeightListView = this.minusHeightForListViewDesktop;
          this.currentMinusHeightGridView = this.minusHeightForGridViewDesktop;
        }
        this.initTableData();
        this.assignTemplateRefs();
      });
    
    this.store.select(fromRoot.getAuthState)
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe((data) => {
      if (!data.authenticated) {
        this.user = new User();
        return;
      }
      if (data.user) {
        this.user = data.user;
      }
    });

    this.fileListService.getCwdSubscription()
    .pipe(takeUntil(this.destroySubscriptions$))
    .subscribe((data) => {
      if (data) {
        this.cwd = data;
      }
    });

    this.paginationConfig$
        .pipe(takeUntil(this.destroySubscriptions$), delay(500))
        .subscribe((paginationConfig)=> {
          if (paginationConfig?.isScrollUpdate || paginationConfig?.isInitialLoading) {
            this.updateThumbnails(paginationConfig);
          }    
    });
  }
  
  private updateThumbnails(paginationConfig : IPaginationConfig): Promise<void> {
    return this.thumbnailsService.getThumbs(this.fileList, paginationConfig);
  }
  /**
  * @param fromBreadcrumb - Flag indicating whether the actions are being triggered from the breadcrumb.
  *                         Used to modify behavior for certain actions like 'Move'.
  */
  fileMenuActions(fromBreadcrumb = false) {
    return [
      {
        name: 'Share as link',
        icon: 'link',
        onClick: this.onLinkDialog,
        divider: true,
        shouldShow: (item) => !item.is_publink && !item.is_readonly
      },
      {
        name: 'Manage link',
        icon: 'link',
        onClick: this.onLinkDialog,
        divider: true,
        shouldShow: (item) => item.is_publink && !item.is_readonly
      },
      {
        name: 'Share folder',
        icon: 'folder-shared-team',
        onClick: this.onInviteCollaborators,
        shouldShow: (item) => {
          return this.hasPermission(this.permissionActions.SHARE_FOLDERS) && (!item.is_shared && item.type == 'dir') || (item.is_shared && item.is_share_root && item.is_hide_share);
        }
      },
      {
        name: 'Manage shared folder',
        icon: 'team-share',
        onClick: this.onManageCollaborators,
        shouldShow: (item) => (item?.is_share_root && !item.is_hide_share)
      },

      {
        name: 'View in Office',
        icon: 'preview',
        onClick: (rowData: FileItem) => {
          this.openOfficeView(rowData)
        },
        shouldShow: (rowData: FileItem) => { return this.isMSOffice(rowData) && this.isSmScreen }
      },
      {
        name: 'View file',
        icon: 'preview',
        onClick: this.onViewFileClick,
        shouldShow: (rowData: FileItem) => { return rowData.type === 'file' && !this.isSmScreen }
      },
      {
        name: 'Open in browser',
        icon: 'open-in-new',
        onClick: (rowData: FileItem) => {
          this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'Open in browser' });
          this.fileViewService.openFile(rowData);
        },
        shouldShow: (rowData: FileItem) => { return this.isOpenable(rowData) && rowData.type === 'file' }
      },
      {
        name: 'Download',
        icon: 'download',
        onClick: (rowData: FileItem) => {
          this.downloadCompat(rowData)
        },
        shouldShow: (rowData: FileItem) => { return this.showDownload(rowData) && rowData.type === 'file'},
        divider: true,
      },

      {
        name: 'Add to starred',
        icon: 'star',
        onClick: (rowData: FileItem, event: Event) => {
          event?.stopPropagation();
          this.fileViewService.updateStarred([rowData], true);
          this.clearSelectionValue = true;
        },
        shouldShow: (rowData) => this.isEnabledAddStarred('add', [rowData]),
        divider: true,
      },
      {
        name: 'Remove from starred',
        icon: 'star-filled',
        onClick: (rowData: FileItem, event: Event) => {
          event?.stopPropagation();
          this.fileViewService.updateStarred([rowData], false);
          this.clearSelectionValue = true;
        },
        shouldShow: (rowData) => this.isEnabledAddStarred('remove', [rowData]),
        divider: true,
      },

      {
        name: 'Edit in Office',
        icon: 'edit',
        onClick: (rowData: FileItem) => {
          this.openOfficeEdit(rowData)
        },
        shouldShow: (rowData: FileItem) => {
          return this.isMSOffice(rowData) && !this.isSmScreen && !rowData.is_readonly
        }
      },
      
      {
        name: 'Rename',
        icon: 'rename',
        onClick: (rowData: FileItem) => {
          this.openRenameModal(rowData);
          if (fromBreadcrumb) {
          this.fromBreadcrumb = fromBreadcrumb;
          }
        },
        shouldShow: (rowData: FileItem) => { return !rowData.is_readonly }
      },
      {
        name: 'Copy',
        icon: 'copy-file',
        onClick: (rowData: FileItem, event: Event) => {
          this.isMoveDialogOpen = true; // Open the Move dialog},
          this.actionMoveOrCopy = WebpathActionType.COPY;
          this.selectedRows = [rowData];
        },
        shouldShow: (item) => {
          return (item.is_deleted === 0 && item.is_readonly === 0);
        }
      },
      {
        name: 'Duplicate',
        icon: 'duplicate',
        onClick: (rowData: IFile, event: Event) => {
          this.duplicateFile([rowData])
        },
        shouldShow: (item) => {
          return (item.is_deleted === 0 && item.is_readonly === 0 && item.type === 'file');
        }
      },
      {
        name: 'Move',
        icon: 'move-file-folder',
        onClick: async (rowData: FileItem, event: Event) => {
          if (fromBreadcrumb) {
            this.moveDialogParentDir = await this.fileListService.getDataNoState(rowData.pid, '0');
          } else {
            this.moveDialogParentDir = undefined;
          }

          this.selectedRows = [rowData];
          this.isMoveDialogOpen = true;
          this.actionMoveOrCopy = WebpathActionType.MOVE;
        },
        shouldShow: (item) => { return !(item.x && !!item.allWritable) && !item.is_readonly }
      },
      {
        name: 'Delete',
        icon: 'delete',
        onClick: (rowData: FileItem, event: Event) => {
          this.selectedRows = [rowData];
          this.openDeleteDialog = true;
        },
        shouldShow: (item) => { return item.is_deleted === 0 && item.is_readonly != 1 },
        divider: true,
      },

      {
        name: 'File info',
        icon: 'info',
        onClick: (rowData: FileItem) => {
          this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'View file info' });

          if (this.isSmScreen) {
            this.dialogService.open(FileInfoDialogComponent, {
              data: {
                file: rowData,
                histId: this.histId,
              }
            });
          }
          else {
            this.activeTab = 'Info';
            this.openInfoPanel = true;  
          }
        },
        shouldShow: (rowData: FileItem) => rowData.type === 'file' && !rowData.is_readonly,
      },
      {
        name: 'Folder info',
        icon: 'info',
        onClick: (rowData: FileItem) => {
          this.headIcon$.next(this.getFileIcon(rowData));
          this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'View folder info' });

          if (this.isSmScreen) {
            this.dialogService.open(FileInfoDialogComponent, {
              data: {
                file: rowData,
                histId: this.histId,
              }
            });
          }
          else {
            this.selectedRows = [rowData];
            this.activeTab = 'Info';
            this.openInfoPanel = true;
          }
        },
        shouldShow: (rowData: FileItem) => rowData.type === 'dir' && !rowData.is_readonly,
      },
      {
        name: 'Version history',
        icon: 'clock',
        onClick: this.onViewHistory,
        shouldShow: (rowData: FileItem) => { return rowData.type == 'file' }
      },
    
    ]
  }

  protected initColumns(): void {
    this.fileListColumns = [
      {
        key: 'head',
        header: 'Name',
        type: CellTypes.templateRef,
        isHead: true,
        width: '48px',
        cell: (element: Record<string, any>) => {
          return this.getFileIcon(element)
        },
      },
      !this.showDeleted && {
        key: 'headIcon',
        header: '',
        type: CellTypes.iconButton,
        width: '48px',
        onCellClick: (rowData: FileItem) => {
          this.fileViewService.updateStarred([rowData], !rowData.is_favorite);
          this.clearSelectionValue = true;
        },
        cell: (element: Record<string, any>) => {
          // Check if the element has a name and determine the icon based on is_favorite
          if (element['name']) {
            return {
              value: element.is_favorite ? 'star-filled' : 'star',
              tooltipText: element.is_favorite ? 'Remove from starred' : 'Add to starred',
            };
          }
          return {
            value:'star',
            tooltipText: 'add to starred',
          };
        },
      },
      {
        key: 'name',
        header: 'Name',
        type: CellTypes.templateRef,
        isSortable: true,
        isPrimary: true,
        cell: (element: Record<string, any>) => {
          return {
            value: `${element['name'] || '--'}`,
            gridSubtext: (element['type'] === 'file')
              ? `${element['date_medium']}`
              : (element['type'] === 'dir' && element['is_shared'] === 1)
                ? 'Shared folder'
                : 'Folder'
          };
        },
        sort: (isSortAsc: boolean) => {
          this.fileListService.sortList('name', isSortAsc);
          this.resetScrollToTop();
          this.handleFilterOrSortingChanged();
        }
      },
      {
        key: 'modified',
        header: 'Modified',
        type: CellTypes.text,
        width: '190px',
        visibleMaxWidth: 725,
        cell: (element: Record<string, any>) => `${element.is_dir ? '--' : element['date_medium']}`,
        isSortable: true,
        sort: (isSortAsc: boolean) => {
          this.fileListService.sortList('usertime', isSortAsc);
          this.resetScrollToTop();
          this.handleFilterOrSortingChanged();
        }
      },
      {
        key: 'size',
        header: 'Size',
        type: CellTypes.text,
        width: '90px',
        visibleMaxWidth: 815,
        isAlignRight: true,
        cell: (element: Record<string, any>) => `${element.is_dir ? '--' : element['filesize']}`,
        isSortable: true,
        sort: (isSortAsc: boolean) => {
          this.fileListService.sortList('size', isSortAsc);
          this.resetScrollToTop();
          this.handleFilterOrSortingChanged();
        }
      },
      {
        key: 'action',
        header: 'Actions',
        type: CellTypes.action,
        width: this.isSmScreen ? '68px' : '152px',
        isAlignRight: true,
        actionLimit: 0,
        actions: [
          ...(this.showDeleted === 0 ? [
            // quick actions
            {
              name: 'Share as link',
              icon: 'link',
              onClick: (rowData, event) => {
                event.stopPropagation();
                this.onLinkDialog(rowData);
              },
              isQuickAction: true,
              shouldShow: (item) => !item.is_publink && !item.is_readonly
            },
            {
              name: 'Manage link',
              icon: 'link',
              isQuickAction: true,
              onClick: (rowData, event) => {
                event.stopPropagation();
                this.onLinkDialog(rowData);
              },
              shouldShow: (item) => item.is_publink && !item.is_readonly
            },
            {
              name: 'Share folder',
              icon: 'folder-shared-team',
              isQuickAction: true,
              onClick: (rowData, event) => {
                event.stopPropagation();
                this.onInviteCollaborators(rowData);
              },
              shouldShow: (item) => {
                return this.hasPermission(this.permissionActions.SHARE_FOLDERS) && (!item.is_shared && item.type == 'dir') || (item.is_shared && item.is_share_root && item.is_hide_share);
              }
            },
            {
              name: 'Read-only folder',
              onClick: () => { },
              shouldShow: (item: FileItem) => { return item.is_readonly === 1 },
              divider: true,
            },
            {
              name: 'Manage shared folder',
              icon: 'team-share',
              isQuickAction: true,
              onClick: (rowData, event) => {
                event.stopPropagation();
                this.onManageCollaborators(rowData);
              },
              shouldShow: (item) => (item?.is_share_root && !item.is_hide_share)
            },
            {
              name: 'Download',
              icon: 'download',
              isQuickAction: true,
              onClick: (rowData: FileItem, event: Event) => {
                event.stopPropagation();
                this.downloadCompat(rowData)
              },
              shouldShow: (rowData: FileItem) => { return this.showDownload(rowData) && rowData.type === 'file' && rowData.is_readonly != 1 },
            },
            // ------------------------

            ...this.fileMenuActions(),
          ] : [
            {
              name: 'Restore',
              icon: 'restore',
              onClick: (rowData: FileItem, event: Event) => {
                this.openDialogRestore = true;
              }
            },
            {
              name: 'Purge',
              icon: 'purge',
              onClick: (rowData: FileItem, event: Event) => {
                this.openDialogPurge = true;
              },
              shouldShow: (rowData: FileItem) => {
                if (!this.isPurgeEnabled()) return false;
                if (rowData.is_readonly) return false;
                return true;
              }
            }
          ])
        ],
      },
    ].filter(Boolean) as Column[];
  }

  // Dynamically return the current minusHeight based on view type
  get currentMinusHeight(): number {
    return this.isGridView ? this.currentMinusHeightGridView : this.currentMinusHeightListView;
  }
  
  initTableData() {
    this.initColumns();
    this.bulkActions = [
      ...(this.showDeleted === 0 ? [
        {
          name: 'Add to starred',
          icon: 'star',
          type: 'primary' as 'primary',
          onClick: (selectedRows: FileItem[]) => {
            this.fileViewService.updateStarred(selectedRows, true);
            this.clearSelectionValue = true;  
          },
          shouldShow: (selectedRows: FileItem[]) => {
            const isAllStarred = this.isEnabledAddStarred('add', selectedRows)
            return isAllStarred;
          },
        },
        {
          name: 'Remove from starred',
          icon: 'star-filled',
          type: 'primary' as 'primary',
          onClick: (selectedRows: FileItem[]) => {
            this.fileViewService.updateStarred(selectedRows, false);
            this.clearSelectionValue = true;
          },
          shouldShow: (selectedRows: FileItem[]) => {
            const isAllUnStarred = this.isEnabledAddStarred('remove', selectedRows)
            return isAllUnStarred;
          },
        },
        {
          name: 'Download',
          icon: 'download',
          type: 'primary' as 'primary',
          onClick: () => {
            this.transferService
              .queueDownload(this.selectedRows)
          },
          shouldShow: (selectedRows: FileItem[]) => {
            return this.showDownload(selectedRows) && selectedRows.every(item => item.type === 'file');
          }
        },

        {
          name: 'Copy',
          icon: 'copy-file',
          type: 'primary' as 'primary',
          onClick: (selectedRows: FileItem[], event: Event) => {
            event.stopPropagation();
            this.isMoveDialogOpen = true; // Open the Move dialog,
            this.actionMoveOrCopy = WebpathActionType.COPY;
            this.selectedRows = selectedRows;
          },
          shouldShow: (selectedRows: FileItem[]) => {
            const isReadOnly = selectedRows.every((item) => !item.is_readonly);
            return isReadOnly;
          }
        },
        {
          name: 'Move',
          icon: 'move-file-folder',
          type: 'primary' as 'primary',
          onClick: (selectedRows: FileItem[], event: Event) => {
            event.stopPropagation();
            this.moveDialogParentDir = undefined;
            this.isMoveDialogOpen = true; // Open the Move dialog,
            this.selectedRows = selectedRows;
            this.actionMoveOrCopy = WebpathActionType.MOVE;
          },
          shouldShow: (selectedRows: FileItem[]) => {
            const isReadOnly = selectedRows.every((item) => !item.is_readonly);
            return isReadOnly;
          }
        },
        {
          name: 'Delete',
          icon: 'delete',
          type: 'primary' as 'primary',
          onClick: () => {
            this.openDeleteDialog = true;
          },
          shouldShow: (selectedRows: FileItem[]) => {
            const isReadOnly = selectedRows.every(item => item.is_deleted === 0 && item.is_readonly != 1)
            return isReadOnly;
          }
        }] : [
        {
          name: 'Restore',
          icon: 'restore',
          type: 'primary' as 'primary',
          onClick: (rowData: FileItem, event: Event) => {
            event.stopPropagation();
            this.openDialogRestore = true;
          }
        },
        {
          name: 'Purge',
          icon: 'purge',
          type: 'primary' as 'primary',
          onClick: (rowData: FileItem, event: Event) => {
            event.stopPropagation();
            this.openDialogPurge = true;
          },
          shouldShow: (selectedRows: FileItem[]) => {
            if (!this.isPurgeEnabled()) return false;
            
            const isReadOnly = selectedRows.every(item => !item.is_readonly)
            return isReadOnly;
          }
        }
      ])];
    this.dragCount = 0;
  }
  
  onFilterIconClicked =  async () => {
    if (this.isLoading) return;
    await this.toggleDeleted();
  }
  
  onInviteCollaborators = (item: IFile) => {
    this.selectedShareItem = [item];
    if (this.openShareFolderDialog) {
      this.openShareFolderDialog = false;
      setTimeout(() => { this.openShareFolderDialog = true; }, 100)
    } else {
      this.openShareFolderDialog = true;
    }
  }
  hasPermission = (permissionKey) => {
    return (!!this.userService.getPermssionByKey(permissionKey));
  }
  isPurgeEnabled() {
    return !this.userService.get('is_disablepurge');
  }
  onLinkDialog = (rowData: FileItem) => {
    this.linkItem = rowData;
    this.openDialogLinkDialog = true;
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.dialoglinkcontent);
  }

  onManageCollaborators = (item: IFile) => {
    this.selectedManageShareItem = [item]
    if (this.openManageShareFolderDialog) {
      this.openManageShareFolderDialog = false;
      setTimeout(() => { this.openManageShareFolderDialog = true; }, 100)
    } else {
      this.openManageShareFolderDialog = true;
    }
    this.openManageShareFolderDialogOpenState = 1;
  }

  public get fabBottom(): number {
    if (this.transferService.showTransferWindow && this.buildTransferItemService.view.isMinimized) {
      return 136; //minimized transfer view(100) + min gap (36)
    } else if (this.transferService.showTransferWindow && !this.buildTransferItemService.view.isMinimized) {
      const transferLength = [...this.buildTransferItemService.view.upload.queue, ...this.buildTransferItemService.view.download.queue, ...this.runUploadFolderService.view.rootItems].filter(item => (item.status !== TransferStatus.STATUS_UPLOAD_CANCELLED && item.status !== TransferStatus.STATUS_DOWNLOAD_CANCELLED)).length;
      if (transferLength > 4) {
        return 516; // max bottom position
      } else {
        return (transferLength * 72) + 200;
      }
    } else {
      return this.isSmScreen ? 80 : 60; // default bottom gap
    }
  }

  openPurgeDialog = () => {
    this.openDialogPurge = true;
  }

  openPurgeAllDialog = () => {
    this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'Purge all', num_items: this.dataSource.length });
    this.selectedRows = this.dataSource;
    this.openDialogPurge = true;
  }

  redirectToUpgrade = () => {
    this.chargebeeService.openPortal();
  }

dragEnter = (event: DragEvent, draggedItem: FileItem) => {
  event.preventDefault();
  this.dragCount++;
  if (draggedItem.type === 'dir') {
    this.dropFolder = draggedItem;
  }else{
    this.dropFolder = null;
  }
}

onDragLeave = (event: DragEvent, row: FileItem) => {
  event.preventDefault();
  this.dragCount--;
  if (this.dragCount === 0) {
    this.dropFolder = null;
  }
  if (this.dragCount < 0) this.dragCount = 0;
}

onDrop = (event: DragEvent, draggedItem: FileItem) => {
  event.preventDefault();
  if (draggedItem.type === 'dir') {
    this.dropFolder = draggedItem;
  }
  this.dragCount = 0;
}

  onRenameSuccess = response => {
    if (this.fromBreadcrumb) {
      this.isLoading = true;
      this.blendService.track(BlendEvent.RENAME_ITEM);
      const viewMode = this.route.snapshot.queryParams['view'] || 'list';
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.navigate(
        ['/files', response.new_sync_id],
        {
          queryParams: { view: viewMode },
          replaceUrl: true,
        }
      ).then(() => {
         this.loadInitialData();
      });
    }
  }

  openRenameModal = (data: FileItem) => {
    this.itemToRename = data;
    this.isRename = true
  }

  duplicateFile = async (itemList: IFile[]) => {
    this.processIndicatorService.showProcessIndicator({ text: 'Duplicating...' });
    const sync_id: number = itemList[0]['pid'];
    if (!sync_id) return;
    const selectedDirPathList: IFile[] = [];
    let duplicateNameMap: IDuplicateNameMap = {};

    this.store.dispatch(new InsertCopyPlaceholders({
      fileIds: itemList.map(item => item.sync_id),
    }));
    const result = await Promise.all(itemList.map((item: IFile) => this.moveActionsService.keepBoth(item, sync_id, itemList, selectedDirPathList, duplicateNameMap)));
    const finish = await this.moveActionsService.startMovingOrCopyExecution(sync_id, itemList, WebpathActionType.COPY, duplicateNameMap)
    if (finish) {

      itemList.map((item: IFile) => this.blendService.track(BlendEvent.DUPLICATE_ITEM, {
        type: item.type,
        size: item.size,
        mime_type: item.mime_type,
      }));

      const subTitle = itemList.length === 1 ? itemList[0].name : itemList.length > 1 ? `${itemList.length} items` : '';
      const message = `Duplicated “${subTitle}”`;
      this.snackbarService.showMessage("success", message);
      this.fileListService.reload();
      this.clearSelectionValue = true;
      this.selectedRows = [];
    } else {
      this.store.dispatch(new DeleteCopyPlaceholders());
      this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
    }
    this.processIndicatorService.hideProcessIndicator();
  }

  public isEnabledAddStarred = (name: 'add' | 'remove', selected: FileItem[]): boolean => {
    const pathlist = [...selected];
    const unTagged = pathlist.find((item) => !item.is_favorite);
    const tagged = pathlist.find((item) => item.is_favorite);
    if (name === 'add' && unTagged && !tagged) {
      return true;
    } else if (name === 'remove' && tagged && !unTagged) {
      return true;
    }
    return false;
  }

  onDropped = (files: FileItem[], droppedOn: FileItem) => {
    if (droppedOn) {
      if (droppedOn.type === 'dir') {
        if (droppedOn.is_readonly) {
          this.dndDialog = {
            opened: true,
            title: 'Editing permissions required',
            message: `You do not have permission to move items into "${droppedOn.name}". Please contact the folder owner for editing permissions.`,
          }
        }
        else if (files.some(file => file.is_share_root) && droppedOn.is_share_root) {
          this.dndDialog = {
            opened: true,
            title: 'Unable to move items',
            message: 'You’re trying to move one or more shared folders. Shared folders cannot be moved into other shared folders.',
          }
        }
        else {
          this.isMoveDialogOpen = true;
          this.selectedRows = files;
          this.actionMoveOrCopy = WebpathActionType.MOVE;
          this.moveDialogParentDir = droppedOn;
          this.autoMove = true;
        }
      }
    }
  }

  onDragOver = (items: FileItem[], dragArea: FileItem) => {
    if (dragArea?.type === 'dir') {
      this.draggedOver = dragArea;
    }
  }

  canDrop = (items: FileItem[], dragArea: FileItem) => {
    return dragArea.type === 'dir';
  }

  onDragStart = (items: FileItem[]) => {
    if (items.some(item => item.is_readonly)) {
      this.dndDialog = {
        opened: true,
        title: 'Read-only folders cannot be moved',
        message: 'At least one of the items you\'re trying to move is a read-only folder and cannot be moved. Unselect them to move your items.',
      }
      return false;
    }
    return true;
  }

  onDragOut = () => {
    this.draggedOver = null;
  }

  closeDndDialog = () => {
    this.dndDialog.opened = false;
  }

  refreshList = () => {
    this.fileListService.reload();
  }
}
